import {

    GET_COUNTRY_SUCCESS,
    ADD_COUNTRY_SUCCESS,
    UPDATE_COUNTRY_SUCCESS,
    DELETE_COUNTRY_SUCCESS,
    COUNTRY_API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
  }
  
  
  const countryDefinition = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_COUNTRY_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
          error: {}
        }
  
      case ADD_COUNTRY_SUCCESS:
        return {
          ...state,
          recordList: [...state.recordList, action.payload],
          error: {}
        }
  
      case UPDATE_COUNTRY_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.map(record =>
            record.guid.toString() === action.payload.guid.toString()
              ? { record, ...action.payload }
              : record
          ),
          error: {}
        }
  
      case DELETE_COUNTRY_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.filter(
            record => record.guid.toString() !== action.payload.toString()
          ),
          error: {}
        }
  
      case COUNTRY_API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
  
        return state
  
    }
  }
  
  export default countryDefinition